import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
export default {
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    paddingRight: ['16px', '16px', '24px'],
    width: '100%',
    flexGrow: 1,
    overflow: 'hidden auto',
    ...reusables.scrollbar()
  },
  productsContainer: {
    width: '100%',
    borderBottom: `1px solid ${theme.rawColors.lightGrey300}`
  },
  productContainer: (selectable = false) => ({
    display: 'flex',
    alignItems: selectable ? 'flex-start' : 'stretch',
    borderTop: `1px solid ${theme.rawColors.lightGrey300}`,
    padding: ['24px 0', '24px 0', '24px 0', '24px 0', '40px 0'],
    width: '100%',
    gap: selectable ? '16px' : 0
  }),
  productCheckbox: {
    flexShrink: 0,
    margin: 'auto 0'
  },
  productContainerInner: (selectable = false) => ({
    display: ['block', 'block', 'flex'],
    width: selectable ? 'auto' : ['75%', '75%', '80%'],
    flex: selectable ? 1 : 'initial',
    minWidth: 0
  }),
  productDetails: {
    display: 'flex',
    flexGrow: 1
  },
  priceDetails: {
    display: 'flex',
    flexDirection: 'column',
    width: ['25%', '25%', '20%']
  },
  priceContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    justifyContent: 'center'
  },
  quantityContainer: {
    flexDirection: ['row-reverse', 'row-reverse', 'column'],
    justifyContent: ['center'],
    display: 'flex'
  },
  structureRow: () => ({
    lineHeight: '140%',
    letterSpacing: theme.letterSpacings.caps,
    pt: '8px',
    '&:first-of-type': {
      pt: 0
    }
  }),
  summaryContainer: {
    padding: ['16px  0px', '16px  0px', '24px 0px', '24px  0px', '24px  0px', '16px 0px'],
    width: '100%',
    maxWidth: ['100%', '100%', '100%', '100%', '908px'],
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    borderTop: `1px solid ${theme.rawColors.lightGrey300}`
  },
  summaryText: {
    fontFamily: theme.fonts.uniformExtra,
    fontWeight: theme.fontWeights.normal,
    fontSize: theme.fontSizes.extraText,
    lineHeight: '100%',
    letterSpacing: theme.letterSpacings.caps,
    color: theme.rawColors.darkGrey700,
    textTransform: 'uppercase',
    textAlign: 'right'
  },
  textContainer: {
    fontFamily: theme.fonts.uniform,
    fontWeight: 400,
    color: theme.rawColors.darkGrey700,
    minHeight: '22px',
    paddingBottom: '8px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '&:first-of-type': {
      mt: '8px'
    }
  },
  amount: (isReduction = false) => ({
    textTransform: 'lowercase',
    textAlign: 'right',
    color: isReduction ? theme.rawColors.accent700 : theme.rawColors.darkGrey700
  }),
  totalContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderTop: `1px solid ${theme.rawColors.lightGrey300}`,
    borderBottom: `1px solid ${theme.rawColors.lightGrey300}`,
    padding: '24px 0px',
    marginTop: '16px'
  },
  paymentBlock: {
    display: 'flex',
    alignItems: ['flex-start', 'flex-start', 'center'],
    position: 'relative',
    flexDirection: ['column', 'column', 'column', 'column', 'row']
  },
  paymentBlockWithPdfLink: {
    display: 'flex',
    alignItems: ['flex-start', 'flex-start', 'flex-start', 'flex-start', 'center'],
    position: 'relative',
    flexDirection: ['column', 'column', 'column', 'column', 'row'],
    paddingTop: ['16px', '16px', '32px', '32px', '0px']
  },
  paymentButton: {
    display: 'flex',
    flexDirection: ['row', 'row', 'row'],
    justifyContent: ['start', 'start', 'start', 'start', 'end'],
    alignItems: 'center',
    width: ['100%', '100%', 'auto', 'auto', '100%'],
    marginLeft: ['initial', 'initial', 'auto'],
    paddingTop: ['16px', '16px', '0px'],
    paddingBottom: ['52px', '45px', 0],
    '@media (max-width: 380px)': {
      pb: '60px'
    },
    a: {
      flexShrink: 0,
      width: 'auto',
      marginLeft: ['auto', 'auto', 'auto', 'auto', 'initial']
    }
  },
  paymentButtonWithLink: {
    display: 'flex',
    flexDirection: ['column', 'column', 'row'],
    justifyContent: ['start', 'start', 'start', 'start', 'end'],
    alignItems: ['flex-start', 'flex-start', 'center'],
    width: ['100%', '100%', 'auto'],
    marginLeft: ['initial', 'initial', 'initial', 'initial', 'auto'],
    paddingTop: ['16px', '16px', '32px', '32px', '0px'],
    paddingBottom: 0
  },
  actionButtonsContainer: {
    display: 'flex',
    flexDirection: ['column', 'column', 'row'],
    width: ['100%', '100%', 'auto']
  },
  linkButtonStyles: {
    marginTop: ['16px', '16px', 0],
    marginLeft: [0, 0, '16px'],
    width: ['100%', '100%', 'auto']
  },
  linkStyles: {
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    fontSize: theme.fontSizes.text,
    lineHeight: '140%',
    letterSpacing: theme.letterSpacings.smallCaps,
    color: theme.rawColors.darkGrey700,
    whiteSpace: 'nowrap',
    '&:hover': {
      color: theme.rawColors.neutralWhite
    }
  },
  paymentLeftTimeText: {
    display: 'flex',
    mr: '10px',
    paddingBottom: ['16px', '16px', 0],
    color: theme.rawColors.accent700,
    fontFamily: theme.fonts.uniform,
    fontSize: theme.fontSizes.caption,
    minWidth: '100px',
    textAlign: ['left', 'left', 'right'],
    whiteSpace: 'nowrap'
  },
  paymentType: {
    display: 'flex',
    alignItems: ['start', 'start', 'center'],
    p: {
      pl: ['0', '0', '24px'],
      fontSize: theme.fontSizes.caption,
      color: theme.rawColors.darkGrey500,
      width: ['100%', '100%', '205px', 'auto', 'auto'],
      flexShrink: 0,
      position: ['absolute', 'absolute', 'relative'],
      bottom: '0'
    }
  },
  paymentDeposit: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    div: {
      width: '24px',
      position: 'relative',
      height: '18px'
    },
    p: {
      pl: '24px',
      fontSize: theme.fontSizes.caption,
      color: theme.rawColors.darkGrey500
    }
  },
  imagesContainer: {
    height: ['unset', 'unset', '24px'],
    display: 'flex',
    flexFlow: 'wrap',
    flexShrink: 0,
    alignItems: 'center',
    rowGap: '20px',
    justifyContent: ['flex-start', 'flex-start', 'flex-end'],
    gap: '8px',
    width: 'auto'
  },
  imageWrapper: (height: number) => ({
    position: 'relative',
    height: `${height}px`,
    display: 'flex',
    flexShrink: 0,
    '& > span': {
      position: 'static !important',
      height: `${height} !important`
    }
  }),
  singleImage: (height: number) => ({
    objectFit: 'contain',
    objectPosition: 'center',
    width: 'auto !important',
    position: 'static !important',
    height: `${height}px !important`
  }),
  returnSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    marginBottom: ['24px', '32px', '46px'],
    width: '100%',
    maxWidth: '100%'
  },
  returnSectionHeader: {
    width: '100%'
  },
  returnSectionTitle: {
    margin: 0
  },
  returnSectionBody: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
    padding: '24px',
    flexDirection: ['column', 'column', 'row'],
    border: `1px solid ${theme.rawColors.lightGrey300}`
  },
  returnInfoText: {
    fontFamily: theme.fonts.uniform,
    fontSize: theme.fontSizes.text,
    color: theme.rawColors.darkGrey700,
    fontWeight: theme.fontWeights.normal,
    lineHeight: '140%',
    margin: 0,
    flex: 1,
    width: ['100%', '100%', 'auto']
  },
  returnButton: {
    fontFamily: theme.fonts.uniform,
    fontSize: theme.fontSizes.text,
    color: theme.rawColors.darkGrey700,
    fontWeight: theme.fontWeights.normal,
    flexShrink: 0,
    width: ['100%', '100%', 'auto'],
    whiteSpace: 'nowrap'
  }
};